import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Custom hook to get an ECC's preconfigured messages for initiating
 * text-from-911 chats. Initial release is hardcoded messages
 */
const usePreconfiguredMessages = () => {
  const eccDisplayName = useSelector(state => state.psaps.currentPSAP?.name);

  const defaultMessage = useMemo(
    () =>
      `Hello, this is ${eccDisplayName} reaching out in response to an emergency`,
    [eccDisplayName],
  );
  const secondMessage = useMemo(
    () =>
      `Hello, this is ${eccDisplayName} reaching out to inquire whether you need emergency assistance, you may respond here or call 911.`,
    [eccDisplayName],
  );

  return [defaultMessage, secondMessage];
};

export default usePreconfiguredMessages;
